/* -------------------------------------------

	Name:		Tempdrop
	Date:		2020/07/20

---------------------------------------------  */
/*global jQuery, document, yall, setTimeout */
var i = 0,
	img_lazy = document.querySelectorAll('img[data-src]:not(.dont)');
for (i = 0; i < img_lazy.length; i = i + 1) {
	img_lazy[i].classList.add('lazy');
}
document.addEventListener('DOMContentLoaded', function () {
	'use strict';
	yall({
		observeChanges: true,
		threshold: 500
	});
});
jQuery(function () {
	"use strict";
	var
		$ = jQuery.noConflict(),
		html_tag = document.documentElement,

		accordion_a = $(document.getElementsByClassName('accordion-a')),
		email_tag = document.getElementsByClassName('email'),
		input_number = $(document.getElementsByClassName('input-number')),
		list_logo = $(document.getElementsByClassName('list-logo')),
		list_product = $(document.getElementsByClassName('list-product')),
		list_quote = $(document.getElementsByClassName('list-quote')),
		list_steps = $(document.getElementsByClassName('list-steps')),
		list_testimonials = $(document.getElementsByClassName('list-testimonials')),
		module_aside = $(document.getElementsByClassName('module-aside')),
		module_featured = $(document.getElementsByClassName('module-featured')),
		module_news = $(document.getElementsByClassName('module-news')),

		Default = {
			utils: {
				mails: function () {
					if (email_tag.length) {
						Array.from(email_tag).filter(function (el) {
							return el.tagName !== 'INPUT' && el.tagName !== 'DIV';
						}).forEach(function (el) {
							el.innerText = el.innerText.replace('//', '@').replace(/\//g, '.');
							if (el.tagName === 'A') {
								el.setAttribute('href', 'mailto:' + el.innerText);
							}
						});
					}
				},
				forms: function () {
					if (input_number.length) {
						input_number.find('input').semanticNumber();
					}
				},
				owl: function () {
					if (list_testimonials.length || list_quote.length) {
						list_testimonials.add(list_quote).each(function () {
							if ($(this).children().length > 1) {
								$(this).owlLayout().children('.inner').owlCarousel({
									loop: true,
									nav: false,
									dots: true,
                                  	autoplay: ($(this).attr('data-autoplay') == "true") ? true : false,
                                    autoplayTimeout: ($(this).attr('data-autoplaytimeout') != "") ? parseInt($(this).attr('data-autoplaytimeout')) : 5000,
									autoHeight: true,
									lazyLoad: true,
									margin: 40,
									items: 1,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function () {
										$(this.$element).owlSemantic();
									}
								});
							}
						});
					}
					if (list_logo.length) {
						list_logo.each(function () {
							if ($(this).children().length > 1) {
								$(this).addClass('mobile-hide').clone().removeClass('mobile-hide').addClass('mobile-only').insertAfter($(this));
								$(this).next('.mobile-only').owlLayout().children('.inner').owlCarousel({
									loop: true,
									nav: true,
									dots: false,
									autoHeight: true,
									lazyLoad: true,
									margin: 20,
									items: 1,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function () {
										$(this.$element).owlSemantic();
									}
								});
							}
						});
					}
					if (list_steps.filter('.a').length) {
						list_steps.filter('.a').each(function () {
							if ($(this).children().length > 1) {
								$(this).addClass('mobile-hide').clone().removeClass('mobile-hide').addClass('mobile-only').insertAfter($(this));
								$(this).next('.mobile-only').owlLayout().children('.inner').owlCarousel({
									loop: true,
									nav: false,
									dots: true,
									autoHeight: true,
									lazyLoad: true,
									margin: 20,
									items: 1,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function () {
										$(this.$element).owlSemantic();
									}
								}).find(':header').append('<a class="toggle" href="./"></a>').children('a.toggle').on('click', function () {
									$(this).closest('.owl-carousel').trigger('next.owl.carousel');
									return false;
								});
							}
						});
					}
					if (module_featured.length) {
						module_featured.find('p:not(.link-btn), figure').each(function () {
							if ($(this).children().length >= 1) {
								$(this).owlLayout().children('.inner').owlCarousel({
									loop: true,
									nav: false,
									dots: false,
									autoHeight: true,
									lazyLoad: true,
									margin: 0,
									items: 1,
									animateOut: 'fadeOut',
									animateIn: 'fadeIn',
									autoplay: true,
									autoplayTimeout: 3000,
									mouseDrag: false,
									touchDrag: false,
									pullDrag: false,
									freeDrag: false,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function () {
										$(this.$element).owlSemantic();
									}
								});
							}
						});
					}
					if (module_news.length) {
						module_news.each(function () {
							if ($(this).children('article').length > 1) {
								$(this).wrapInner('<div class="inner owl-carousel"></div>').children('.inner').children(':header').prependTo($(this));
								$(this).find('article').wrap('<div class="item"></div>');
								$(this).children('.inner').owlCarousel({
									loop: true,
									nav: false,
									dots: true,
									autoHeight: true,
									lazyLoad: true,
									margin: 20,
									items: 1,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function () {
										$(this.$element).owlSemantic();
									}
								});
							}
						});
					}
					if (list_product.length) {
						list_product.each(function () {
							if ($(this).children().length > 1) {
								$(this).owlLayout();
								$(this).append('<ul class="pager custom"></ul>').children('.inner').children().each(function (i) {
									$(this).find('img:first').clone().wrap('<a href="./" role="button" data-slide-index="' + i + '"></a>').parent().appendTo($(this).parents('.is-slider:first').find('.pager.custom'));
								});
								$(this).children('.inner').owlCarousel({
									nav: true,
									dots: false,
									autoHeight: true,
									loop: false,
									items: 1,
									margin: 0,
									onInitialized: function () {
										$(this.$element).owlSemantic();
									},
									onTranslated: function (event) {
										$(this.$element).owlSemantic();
										$(this.$element).parents('.is-slider:first').find('[data-slide-index]').removeClass('current').parent().children('[data-slide-index="' + event.item.index + '"]').addClass('current');
									}
								});
								$(this).find('a[data-slide-index]').wrap('<li></li>').each(function () {
									if ($(this).parent().is(':first-child')) {
										$(this).addClass('current').attr('aria-pressed', true);
									} else {
										$(this).attr('aria-pressed', false);
									}
								}).on('click', function () {
									var n = $(this),
										f = n.parents('.is-slider:first');
									f.find('.pager a[data-slide-index]').each(function (k, v) {
										if ((v = $(v)).is('[data-slide-index="' + n.attr('data-slide-index') + '"]')) {
											v.attr('aria-pressed', true).addClass('current');
										} else {
											v.attr('aria-pressed', false).removeClass('current');
										}
									});
									f.find('.owl-carousel:first').trigger('to.owl.carousel', n.attr('data-slide-index'));
									return false;
								});
							}
						});
					}
				},
				mobile: function () {
					if (jQuery.browser.mobile) {
						html_tag.classList.add('mobile');
					} else {
						html_tag.classList.add('no-mobile');
					}
				},
				done: function () {
					var tag = document.createElement('script');
					tag.src = scripts_async_url;
					document.body.appendChild(tag);
				},
				miscellaneous: function () {
					if (module_aside.length) {
						module_aside.filter(':has(:header, figure)').each(function () {
							$(this).find('figure').addClass('mobile-hide').clone().removeClass('mobile-hide').addClass('mobile-only').insertAfter($(this).find(':header:first'));
						});
					}
					if (accordion_a.length) {
						accordion_a.semanticAccordion();
					}
				}
			}

		};
	setTimeout(function () {
		Default.utils.mails();
		Default.utils.forms();
		Default.utils.owl();
		Default.utils.miscellaneous();
		Default.utils.mobile();
		Default.utils.done();
	}, 0);
});

/*!*/
